<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      {{ titleName }}
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="sanctionHeaders"
          :items="sanctionItems"
          v-bind:options.sync="paginationSanction"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="sanctionItems.totalElements"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.name }}</td>
              <td>{{ row.item.quality }}</td>
              <td>{{ row.item.matchPct }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
    <v-card-actions right>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click.prevent="closeDialog">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
export default {
  data() {
    return {
      titleName: 'Matched Names',
      sanctionHeaders: [
        { text: 'Names', align: 'left', value: 'name' },
        { text: 'Quality', value: 'quality' },
        { text: 'Matched %', value: 'matchPct' }
      ],
      totalItemsSanction: 0,
      paginationSanction: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    }
  },
  props: {
    sanctionItems: Array
  },
  mixins: [TableConst.default]
}
</script>

<style>
</style>
